import { useSelector } from "react-redux";
import { useTotalFactura } from "../../../hook/useTotalFactura";
import { puedeEmitir, motivoNoEmitir, tienePlanAplicado } from "../../../utils/facturaCrear";
import "../../../styles/FacturaCrear.css";

/* ============================================================================
   CREAR FACTURA · resumen

   Sustituye a la barra morada `FACTURAR $15.00`, que parecía un renglón de
   total más y no un botón, con `CANCELAR` debajo con el mismo peso visual.

   QUÉ SE MUESTRA Y QUÉ NO: Subtotal, IVA y Total, que es exactamente lo que
   `useTotalFactura` devuelve. La maqueta pedía además una línea de "Descuento
   por promoción" -- NO EXISTE: el cálculo es
   `subtotal = Σ(cantidad × precio)`, sin ninguna resta, y ninguna respuesta
   trae ese desglose. Inventar la línea sería inventar un número.

   Tampoco hay "Guardar borrador": el sistema no guarda borradores. El único
   botón secundario real es descartar, que es el `CANCELAR` de siempre y
   despacha exactamente lo mismo.

   NINGÚN CÁLCULO CAMBIA. Esta fase sólo cambia dónde y cómo se muestran los
   números que ya se calculaban.
   ========================================================================== */

export default function Resumen({ onEmitir, onDescartar }) {
    const { subtotal, iva, total } = useTotalFactura();
    const procedimientos = useSelector((state) => state.facturaredux.procedimientos) || [];
    const tienePlan = tienePlanAplicado(procedimientos);

    const habilitado = puedeEmitir({ total, tienePlan });
    const motivo = motivoNoEmitir({ total, tienePlan, procedimientos });

    return (
        <div className="fcrear__card fcrear__card--pie fcrear__resumen">
            <div className="fcrear__ch">
                <span className="fcrear__ct">Resumen</span>
            </div>

            <div className="fcrear__resumen-cuerpo">
                <div className="fcrear__linea">
                    <span>Subtotal</span>
                    <span className="fcrear__linea-val">${subtotal.toFixed(2)}</span>
                </div>
                <div className="fcrear__linea">
                    <span>IVA</span>
                    <span className="fcrear__linea-val">${iva.toFixed(2)}</span>
                </div>

                <div className="fcrear__divisoria" />

                <div className="fcrear__linea fcrear__linea--total">
                    <span>Total a facturar</span>
                    <span className="fcrear__linea-val">${total.toFixed(2)}</span>
                </div>

                <button
                    type="button"
                    className="fcrear__btn fcrear__btn--primario fcrear__btn--ancho"
                    disabled={!habilitado}
                    onClick={onEmitir}
                    title={motivo || "Emitir factura"}
                >
                    Emitir factura
                </button>

                {motivo && <p className="fcrear__resumen-motivo">{motivo}</p>}

                <button
                    type="button"
                    className="fcrear__enlace"
                    onClick={onDescartar}
                >
                    Descartar
                </button>
            </div>
        </div>
    );
}
